import React, { Component } from 'react'
import { navigate } from '@reach/router'

import { Table, Header, ListFilters, Page } from 'components'
import { ArticleApi } from 'api'
import { pages, Article, operations } from 'types'
import { editArticle, addArticle } from 'utils/endpoints'
import { isSuperAdmin } from 'utils/permission'
import { matchesListSearch } from 'utils/listFilters'
import { getListFilters, persistListFilters } from 'utils/listViewState'

interface Props {
  path: string
}

interface State {
  articles: Article[]
  search: string
  visibilityFilter: string
}

export default class ArticlesPage extends Component<Props, State> {
  state: State = {
    articles: [],
    ...getListFilters(pages.GET_ARTICLES, {
      search: '',
      visibilityFilter: 'all',
    }),
  }
  page?: Page

  async componentDidMount() {
    this.refreshArticles()
  }

  componentDidUpdate(_previousProps: Props, previousState: State) {
    const { search, visibilityFilter } = this.state
    if (previousState.search !== search || previousState.visibilityFilter !== visibilityFilter) {
      persistListFilters(pages.GET_ARTICLES, { search, visibilityFilter })
    }
  }

  refreshArticles = async () => {
    try {
      const articles = await ArticleApi.getArticles()
      this.setState({ articles })
    } catch (e) {}
  }

  onOperationClick = async (operation: operations, articleId: string) => {
    if (operation === 'Modifica') {
      navigate(editArticle + articleId)
    }
    if (operation === 'Cancella') {
      this.page?.showConfirmDialog('Cancellazione Articolo', 'Vuoi davvero cancellare questo articolo', async () => {
        try {
          await ArticleApi.deleteArticle(articleId)
          this.page?.showNotification({ message: 'Articolo cancellato.', type: 'success' })
          this.refreshArticles()
        } catch (error) {}
      })
    }
  }

  onEdit = (packId: string) => {
    navigate(editArticle + packId)
  }

  getDateString = (date: Date) => {
    const day = date.getUTCDate() < 10 ? '0' + date.getUTCDate() : date.getUTCDate()
    const month = date.getUTCMonth() + 1 < 10 ? '0' + (date.getUTCMonth() + 1) : date.getUTCMonth() + 1
    const year = date.getUTCFullYear().toString().substr(2, 4)
    const hour = date.getHours() < 10 ? '0' + date.getHours() : date.getHours()
    const minutes = date.getUTCMinutes() < 10 ? '0' + date.getUTCMinutes() : date.getUTCMinutes()
    return day + '/' + month + '/' + year + ' ' + hour + ':' + minutes
  }

  getValues = (packs: Article[]): any => {
    const rows = packs.map((article: Article) => {
      const isVisible = article.visible ? 'Si' : 'No'
      const updateDate = article.updatedAt ? new Date(article.updatedAt) : new Date()
      const lastModified = this.getDateString(updateDate)
      const operations = []
      operations.push('Modifica')
      operations.push('Cancella')
      return {
        id: article._id!,
        values: [article.title, article.position, isVisible, lastModified],
        operations: operations,
      }
    })
    return rows
  }

  getFilteredArticles = () => {
    const { articles, search, visibilityFilter } = this.state

    return articles.filter((article) => {
      const matchesSearch = matchesListSearch(search, [article.title, article.author])
      const matchesVisibility = visibilityFilter === 'all' || String(article.visible) === visibilityFilter
      return matchesSearch && matchesVisibility
    })
  }

  render() {
    const keys = ['Titolo', 'Posizione', 'Visibile', 'Ultima modifica']
    const filteredArticles = this.getFilteredArticles()
    const values = this.getValues(filteredArticles)
    const buttons = [{ title: 'Crea un articolo', href: addArticle }]
    return (
      <Page ref={(ref) => (this.page = ref!)} page={pages.GET_ARTICLES}>
        {isSuperAdmin() && <Header title={'Articoli'} buttons={buttons} />}
        {!isSuperAdmin() && <Header title={'Articoli'} />}
        <ListFilters
          searchValue={this.state.search}
          searchPlaceholder="Titolo o autore"
          onSearchChange={(search) => this.setState({ search })}
          filters={[
            {
              key: 'visibilityFilter',
              label: 'Visibilità',
              value: this.state.visibilityFilter,
              options: [
                { label: 'Tutti', value: 'all' },
                { label: 'Visibili', value: 'true' },
                { label: 'Non visibili', value: 'false' },
              ],
            },
          ]}
          onFilterChange={(_, visibilityFilter) => this.setState({ visibilityFilter })}
          onReset={() => this.setState({ search: '', visibilityFilter: 'all' })}
          resultCount={filteredArticles.length}
          totalCount={this.state.articles.length}
        />
        <Table keys={keys} rows={values} onOperationClick={this.onOperationClick} />
      </Page>
    )
  }
}
